import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext.js";
import { getAdminJwt } from "../../lib/auth-storage.js";
import { isLegacyGovernanceMode } from "../../lib/auth-mode.js";

/**
 * Allows the app shell when the user has a valid session JWT or legacy admin API key (dev).
 */
export function RequireAuth() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const legacy = isLegacyGovernanceMode();
  const hasJwt = Boolean(getAdminJwt());

  if (loading && hasJwt) {
    return (
      <div className="min-h-screen bg-card flex items-center justify-center text-muted">
        Loading…
      </div>
    );
  }

  if (!user && !legacy) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
